var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4358 16.2855C11.9625 16.2855 11.5787 16.6693 11.5787 17.1426C11.5787 17.6159 11.9625 18 12.4358 18C12.9091 18 13.2929 17.6159 13.2929 17.1426C13.2929 16.6693 12.9099 16.2855 12.4358 16.2855ZM14.2358 6H11.3644C9.82853 6 8.57874 7.24979 8.57874 8.78565V9.21421C8.57874 9.57046 8.86668 9.85706 9.22158 9.85706C9.57648 9.85706 9.86442 9.57046 9.86442 9.21421V8.78565C9.86442 7.95853 10.5373 7.28569 11.3644 7.28569H14.2358C15.1331 7.28569 15.8643 8.01692 15.8643 8.91422C15.8643 9.52117 15.5311 10.0732 14.9938 10.3555L13.0518 11.3785C12.251 11.7856 11.7929 12.5865 11.7929 13.4623V13.9284C11.7929 14.2833 12.0809 14.5715 12.4358 14.5715C12.7907 14.5715 13.0786 14.2846 13.0786 13.9284V13.4623C13.0786 13.0635 13.298 12.6998 13.6513 12.5139L15.5924 11.4923C16.5527 10.9874 17.15 9.99902 17.15 8.91422C17.15 7.30738 15.8429 6 14.2358 6Z",
    fill: "#B3C0C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.36438,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#B3C0C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareInfo);
export default __webpack_public_path__ + "static/media/share-info.567f849c745f9a1f99581b153ac34a76.svg";
export { ForwardRef as ReactComponent };